// Ícones próprios do painel (complementam o mapa fixo de compartilhado/ui/icones.tsx, DESIGN §4).
// Um nome por conceito: ninguém escolhe outro ícone para a mesma coisa dentro do painel.
import {
  ArrowDown,
  ArrowRight,
  ArrowUp,
  GripVertical,
  Power,
  Undo2,
  BadgeCheck,
  CalendarDays,
  CalendarPlus,
  Clock,
  CloudRain,
  Copy,
  Dices,
  Download,
  EllipsisVertical,
  FileText,
  Handshake,
  History,
  Lightbulb,
  MapPin,
  MessagesSquare,
  Pencil,
  Pin,
  Printer,
  RefreshCw,
  Scale,
  ShieldAlert,
  SlidersHorizontal,
  Trash2,
  Upload,
  UserPlus,
  Maximize2,
  Archive,
  Rocket,
  Megaphone,
  KeyRound,
  Shuffle,
  type LucideIcon,
} from "lucide-react";

export const IconesPainel = {
  carteira: Shuffle,
  /** Troca "de → para" (pedido de transferência). */
  seta: ArrowRight,
  permissoes: KeyRound,
  timeline: MessagesSquare,
  eventos: CalendarDays,
  agendar: CalendarPlus,
  feedback: Lightbulb,
  indicacoes: UserPlus,
  avaliacoes: Scale,
  pontosExtras: BadgeCheck,
  suspeitas: ShieldAlert,
  auditoria: History,
  chuva: CloudRain,
  copiar: Copy,
  sorteio: Dices,
  baixar: Download,
  enviarArquivo: Upload,
  menu: EllipsisVertical,
  template: FileText,
  parceiro: Handshake,
  local: MapPin,
  editar: Pencil,
  fixar: Pin,
  imprimir: Printer,
  sincronizar: RefreshCw,
  ajustes: SlidersHorizontal,
  excluir: Trash2,
  horario: Clock,
  telaCheia: Maximize2,
  arquivar: Archive,
  publicar: Rocket,
  aviso: Megaphone,
  // Conquistas cadastráveis (docs/prototipo/conquistas-cadastro.html §4, §9, §11)
  alca: GripVertical,
  desligar: Power,
  desfazer: Undo2,
  subir: ArrowUp,
  descer: ArrowDown,
} satisfies Record<string, LucideIcon>;
